import { render, staticRenderFns } from "./weeklyPlan.vue?vue&type=template&id=1dec6276&"
import script from "./weeklyPlan.vue?vue&type=script&lang=js&"
export * from "./weeklyPlan.vue?vue&type=script&lang=js&"
import style0 from "./weeklyPlan.vue?vue&type=style&index=0&id=1dec6276&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports